import gql from 'graphql-tag';
import { UserDetailsFragment } from '../fragments';

export default gql`
query user($filters: UserFilters, $sortBy: UserSort, $count: Int!, $page: Int) {
    listUsers(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        data {
            ...UserDetailsFragment
        }
    }
}
${UserDetailsFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/user.ts